<template>
  <div class="main-logo">
    <div v-if="$country === 'ru'" class="ru-header">
      <div class="ru-title">супервыигрыш</div>
      <CurrentDate />
    </div>
    <img v-else-if="$country === 'kz'" src="@/assets/images/KZ/jackpot.png" class="kz-title" />
  </div>
</template>

<script>
import CurrentDate from './RU/CurrentDate.vue';

export default {
  name: 'MainLogo',
  components: { CurrentDate },
};
</script>

<style scoped>
.kz-title {
  height: 180px;
}

.ru-header {
  position: relative;
  width: 1089px;
}

.ru-title {
  width: 1089px;
  height: 170px;
  font-family: 'ONY Track', serif;
  font-weight: 900;
  font-size: 210px;
  color: #E3E5E4;
  line-height: 80%;
  letter-spacing: 0;
  text-align: center;
  text-transform: uppercase;
}
</style>
